module.exports = __webpack_public_path__ + "img/shangilia_logo.589b662a.png";